import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { ApiUrl } from 'Services/Services';
import { toast } from 'react-toastify';

function AddBranch() {
  const [organizationId , setOrganizationId] = useState();
  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [radius, setRadius] = useState(1);
  const [location, setLocation] = useState({
    latitude: null,
    longitude: null,
    address: '',
  });

  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const geocoder = useRef(null);
  const mapInstance = useRef(null);
  const circleRef = useRef(null);

  const autocompleteInputRef = useRef(null);

  const FetchOrganizationId = async () =>{
    const id = await localStorage.getItem('organizationId');
    setOrganizationId(JSON.parse(id));

  }
  useEffect(() => {
    if (window.google) {
      initMap();
    }
    FetchOrganizationId()
  }, []);

  const initMap = () => {
    geocoder.current = new window.google.maps.Geocoder();
    const defaultPosition = { lat: 31.5204, lng: 74.3587 };

    mapInstance.current = new window.google.maps.Map(mapRef.current, {
      center: defaultPosition,
      zoom: 13,
    });

    const autocomplete = new window.google.maps.places.Autocomplete(
      autocompleteInputRef.current,
      { types: ['geocode'] }
    );

    autocomplete.bindTo('bounds', mapInstance.current);

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      if (!place.geometry || !place.geometry.location) return;

      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      mapInstance.current.panTo({ lat, lng });
      mapInstance.current.setZoom(15);

      placeMarker(lat, lng);
      setLocation({
        latitude: lat,
        longitude: lng,
        address: place.formatted_address || place.name,
      });
    });

    mapInstance.current.addListener('click', (e) => {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();

      setLocation((prev) => ({
        ...prev,
        latitude: lat,
        longitude: lng,
      }));

      placeMarker(lat, lng);
      getAddress(lat, lng);
    });
  };

  const placeMarker = (lat, lng) => {
  if (markerRef.current) {
    markerRef.current.setMap(null);
  }

  markerRef.current = new window.google.maps.Marker({
    position: { lat, lng },
    map: mapInstance.current,
  });

  drawCircle(lat, lng, radius);
};

const drawCircle = (lat, lng, rad) => {
  if (circleRef.current) {
    circleRef.current.setMap(null);
  }

  circleRef.current = new window.google.maps.Circle({
    strokeColor: "#3b82f6",
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: "#3b82f6",
    fillOpacity: 0.2,
    map: mapInstance.current,
    center: { lat, lng },
    radius: rad * 1000, // km to meters
  });
};

useEffect(() => {
  if (location.latitude && location.longitude) {
    drawCircle(location.latitude, location.longitude, radius);
  }
}, [radius]);

  const getAddress = (lat, lng) => {
    geocoder.current.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === 'OK' && results[0]) {
        setLocation((prev) => ({
          ...prev,
          address: results[0].formatted_address,
        }));
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      name,
      address: location.address,
      latitude: location.latitude,
      longitude: location.longitude,
      phoneNumber: phoneNumber,
      radius,
      organizationId: organizationId,
    };

    try {
      await axios.post(`${ApiUrl}/branches`, payload);
     toast.success('Branch Added SuccessFully')
      setName('');
      setRadius(1);
      setLocation({ latitude: null, longitude: null, address: '' });
    } catch (err) {
      console.error(err);
     toast.warn(err)
    }
  };

  return (
    <div className="max-w-5xl mx-auto px-4 py-8">
      <div className="bg-white shadow-lg rounded-xl p-6">
        <h2 className="text-2xl font-semibold text-gray-800 mb-6">
          Add New Branch
        </h2>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Branch Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Branch Name
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="w-full border border-gray-300 focus:ring-blue-500 focus:border-blue-500 rounded-md px-4 py-2"
              placeholder="e.g., Food Republic - Gulberg"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Branch PhoneNumber
            </label>
            <input
              type="text"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              required
              className="w-full border border-gray-300 focus:ring-blue-500 focus:border-blue-500 rounded-md px-4 py-2"
              placeholder="e.g., Food Republic - Gulberg"
            />
          </div>

          {/* Search and Map */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Search Location
            </label>
            <input
              type="text"
              value={location.address}
              ref={autocompleteInputRef}
              placeholder="Search for a place"
              className="w-full mb-3 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 rounded-md px-4 py-2"
            />
            <div
              ref={mapRef}
              className="w-full h-96 rounded-lg border border-gray-300"
            ></div>
            {location.address && (
              <p className="text-sm text-gray-600 mt-2">
                📍 <strong>Selected Address:</strong> {location.address}
              </p>
            )}
          </div>

          {/* Radius */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Radius (km)
            </label>
            <input
              type="number"
              value={radius}
              onChange={(e) => setRadius(e.target.value)}
              min={1}
              required
              className="w-full border border-gray-300 focus:ring-blue-500 focus:border-blue-500 rounded-md px-4 py-2"
            />
          </div>

          {/* Submit */}
          <div className="pt-2">
            <button
              type="submit"
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-2 rounded-md transition duration-200"
            >
              Save Branch
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddBranch;
